export const async_homedepot_search = {
  input: "milwaukee cordless drill",
  result: `{
  "success": true,
  "payload": {
    "search_results": [
      {
        "position": 1,
        "product": {
          "title": "Milwaukee M18 18V Lithium-Ion Brushless Cordless 1/2 in. Compact Drill/Driver with One 2.0 Ah Battery, Charger and Tool Bag",
          "link": "https://www.homedepot.com/p/Milwaukee-M18-18V-Lithium-Ion-Brushless-Cordless-1-2-in-Compact-Drill-Driver-with-One-2-0-Ah-Battery-Charger-and-Tool-Bag-3601-21P/325479354",
          "brand": "Milwaukee",
          "item_id": "325479354",
          "model_number": "3601-21P",
          "primary_image": "https://images.thdstatic.com/productImages/f7657d2a-7e39-43c5-9ea3-100d77b8de81/svn/milwaukee-power-drills-3601-21p-64_1000.jpg",
          "rating": 4.6,
          "ratings_total": 2488
        },
        "offers": { "primary": { "price": 199, "symbol": "$", "currency": "USD" } }
      },
      {
        "position": 2,
        "product": {
          "title": "Milwaukee M18 FUEL 18V Lithium-Ion Brushless Cordless 1/2 in. Hammer Drill/Driver (Tool-Only)",
          "link": "https://www.homedepot.com/p/Milwaukee-M18-FUEL-18V-Lithium-Ion-Brushless-Cordless-1-2-in-Hammer-Drill-Driver-Tool-Only-2904-20/320326855",
          "brand": "Milwaukee",
          "item_id": "320326855",
          "model_number": "2904-20",
          "primary_image": "https://images.thdstatic.com/productImages/66a60fa5-5897-46a9-bfb4-60e508951421/svn/milwaukee-hammer-drills-2904-20-64_1000.jpg",
          "rating": 4.7,
          "ratings_total": 1698
        },
        "offers": { "primary": { "price": 229, "symbol": "$", "currency": "USD" } }
      },
      {
        "position": 3,
        "product": {
          "title": "Milwaukee M18 FUEL 18V Lithium-Ion Brushless Cordless Hammer Drill and Impact Driver Combo Kit (2-Tool) with 2 Batteries",
          "link": "https://www.homedepot.com/p/Milwaukee-M18-FUEL-18V-Lithium-Ion-Brushless-Cordless-Hammer-Drill-and-Impact-Driver-Combo-Kit-2-Tool-with-2-Batteries-3697-22/320326787",
          "brand": "Milwaukee",
          "item_id": "320326787",
          "model_number": "3697-22",
          "primary_image": "https://images.thdstatic.com/productImages/c83a98b4-2b2a-4537-9a1b-16f4adc8fff6/svn/milwaukee-power-tool-combo-kits-3697-22-64_1000.jpg",
          "rating": 4.8,
          "ratings_total": 4081
        },
        "offers": { "primary": { "price": 399, "symbol": "$", "currency": "USD" } }
      }
    ],
    "related_queries": [
      { "query": "milwaukee hammer drill" },
      { "query": "milwaukee m18 cordless drill" },
      { "query": "dewalt cordless drill" }
    ],
    "pagination": {
      "total_results": 2741,
      "total_pages": 115,
      "current": { "page": 1, "link": "https://www.homedepot.com/s/milwaukee%20cordless%20drill?Nao=0" },
      "next": { "page": 2, "link": "https://www.homedepot.com/s/milwaukee%20cordless%20drill?Nao=24" }
    }
  }
}`
};
